export const types = {
    MODAL_SINGLE_OPEN: "MODAL_OPEN_SINGLE",
    MODAL_SINGLE_CLOSE: "MODAL_CLOSE_SINGE"
};

export const actions = {
    openSingleModal: (payload = {}) => ({
        type: types.MODAL_SINGLE_OPEN,
        payload
    }),
    closeSingleModal: (payload = {}) => ({
        type: types.MODAL_SINGLE_CLOSE,
        payload
    })
}
